import Icon from '../components/Icon.vue'

Icon.register({
  'file-alt': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M224 136c0 13.2 10.8 24 24 24h136v328c0 13.3-10.7 24-24 24h-336c-13.3 0-24-10.7-24-24v-464c0-13.3 10.7-24 24-24h200v136zM288 372v-8c0-6.6-5.4-12-12-12h-168c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12zM288 308v-8c0-6.6-5.4-12-12-12h-168c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12zM288 236c0-6.6-5.4-12-12-12h-168c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-8zM384 121.9v6.1h-128v-128h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-alt.js
// module id = 1324
// module chunks = 0